import FiltersWrapper from '@/src/components/common/srp/filters'
import SwipeableDrawerWithBackNavigation from '@/src/components/common/ui/swipeableDrawer'
import { MOBILE } from '@/src/constants/deviceTypes'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { Box, Button } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'
import SortOptionsSelector from './sortOptionsSelector'
import SrpFilterAndSortTabBar from './srpFilterAndSortTabsBar'

const SrpFilterAndSortTabsAndDrawerWrapper = () => {
    const t = useTranslations('common')

    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
    // Add sort drawer state
    const [sortDrawerOpen, setSortDrawerOpen] = useState(false)

    const handleFilterClick = useCallback(() => {
        setFilterDrawerOpen(true)
    }, [])

    const filterDrawerClose = useCallback(() => {
        setFilterDrawerOpen(false)
    }, [])

    const handleSortClick = useCallback(() => {
        setSortDrawerOpen(true)
    }, [])

    const handleSortDrawerClose = useCallback(() => {
        setSortDrawerOpen(false)
    }, [])

    //apply filters button just close the drawer , all apply logic are handled by there respective filter wrapper component
    const handleApplyClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e?.stopPropagation?.()
            filterDrawerClose()
        },
        [filterDrawerClose]
    )

    return (
        <>
            <Box display="flex" gap={1}>
                <SrpFilterAndSortTabBar onFilterClick={handleFilterClick} onSortClick={handleSortClick} t={t} />
            </Box>
            {/* Filter Drawer */}
            <SwipeableDrawerWithBackNavigation anchor="bottom" open={filterDrawerOpen} onClose={filterDrawerClose}>
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        px: 1.5
                    }}
                >
                    {filterDrawerOpen && <FiltersWrapper deviceType={MOBILE} />}
                </Box>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', p: 1 }}>
                    <Button variant="contained" fullWidth color="primary" onClick={handleApplyClick}>
                        {t('apply')}
                    </Button>
                </Box>
            </SwipeableDrawerWithBackNavigation>
            {/* Sort Drawer */}
            <SwipeableDrawerWithBackNavigation
                anchor="bottom"
                open={sortDrawerOpen}
                onClose={handleSortDrawerClose}
                sx={{ height: 'auto' }}
            >
                {sortDrawerOpen && (
                    <ErrorBoundaryWrapper identifier="sortOptionsSelector-mobile-srp">
                        <SortOptionsSelector onApply={handleSortDrawerClose} />
                    </ErrorBoundaryWrapper>
                )}
            </SwipeableDrawerWithBackNavigation>
        </>
    )
}

export default SrpFilterAndSortTabsAndDrawerWrapper
